import { Pipe, PipeTransform } from '@angular/core';
import { Portal } from '../portal.model';

@Pipe({
  name: 'menuFilter'
})
export class MenuFilterPipe implements PipeTransform {

  transform(portals: Portal[], parentId: number): any {
    const filteredPortal = portals.filter(o => o.ParentId == parentId && o.ShowAsMenu == true);
    filteredPortal.sort((a, b) =>
      a.PortalName.localeCompare(b.PortalName)
    );

    return filteredPortal;
  }
}